import { render, staticRenderFns } from "./withdrawal.vue?vue&type=template&id=4864c2c5&lang=pug&"
import script from "./withdrawal.ts?vue&type=script&lang=ts&"
export * from "./withdrawal.ts?vue&type=script&lang=ts&"
import style0 from "./withdrawal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports